/**
 * 接口域名的管理
 */
import { getQueryVariable } from '../util/util';
import { getLocalStorage, setLocalStorage } from '../util/cookie';
import { APPID } from '../util/const';
let isDebugger;
// const playerVersion = getQueryVariable('playerVersion') || '2.3.1';
// localStorage.setItem('playerVersion', playerVersion);

const playerIsTest = getQueryVariable('playerIsTest') || '0';
localStorage.setItem('playerIsTest', playerIsTest);
const playerVersionIsTest = getQueryVariable('playerVersionIsTest') || '0';
localStorage.setItem('playerVersionIsTest', playerVersionIsTest);

const isMP4 = getQueryVariable('isMP4') || '0';
const domain = location.hostname;

localStorage.setItem('isMP4', isMP4);
if (getLocalStorage('isDebugger')) {
  isDebugger = getLocalStorage('isDebugger');
} else {
  isDebugger = getQueryVariable('debugger');
  setLocalStorage('isDebugger', isDebugger);
}
if (['tv.iflix.com', 'test.iflix.com'].includes(domain)) {
  global.constants = {
    privacyUrl: 'https://www.iflix.com/privacy',
    termsUrl: 'https://www.iflix.com/static/terms-en.html',
    rootValue: '192', // 分辨率换算rem基数
    appid: APPID.IFLIX,
  };
} else {
  global.constants = {
    privacyUrl: 'https://wetv.vip/privacy',
    termsUrl: 'https://wetv.vip/static/terms-en.html',
    rootValue: '192', // 分辨率换算rem基数
    appid: APPID.WETV,
  };
}
global.base = {
  // 首页频道页
  GetHomePage: 'trpc.video_app_international.trpc_home_page.HomePage/GetHomePage',
  // 实时搜索
  RPCSmartBox: 'trpc.video_app_international.trpc_kt_search.TVSearch/RPCSmartBox',
  // 搜索
  RPCSearch: 'trpc.video_app_international.trpc_kt_search.TVSearch/RPCSearch',
  // 详情页
  // eslint-disable-next-line
  getDetail: 'trpc.video_app_international.trpc_d_video_detail.VideoDetailData/GetDetailPage',
  // 列表页
  // eslint-disable-next-line
  GetFilterPage: 'trpc.video_app_international.trpc_filter_page.FilterPage/GetFilterPage',
  // 搜索热榜
  // eslint-disable-next-line
  GetSearchHotList: 'trpc.video_app_international.trpc_kt_search.TVSearch/RPCRank',
  // 观看历史
  // eslint-disable-next-line
  GetRPCQueryHistory: 'trpc.video_app_international.trpc_history_read.HistoryRead/RPCQueryBaseHistoryList',
  // 观看历史海报
  // eslint-disable-next-line
  GetRPCQueryHistoryUiData: 'trpc.video_app_international.trpc_history_read.HistoryRead/RPCQueryHistoryUiData',
  // 同步服务器时间
  RPCSyncTime: 'trpc.video_app_international.trpc_history_read.HistoryRead/RPCSyncTime',
  // 观看历史海报上报删除
  // eslint-disable-next-line
  RPCReportHistory: 'trpc.video_app_international.trpc_history_write.HistoryWrite/RPCReportHistory',
  // 观看历史海报上报全部删除
  // eslint-disable-next-line
  RPCReportDelAllHistory: 'trpc.video_app_international.trpc_history_write.HistoryWrite/RPCReportDelAllHistory',
  // 扫码登录
  GetQrInfo: 'video_i18n.QrWrite/GetQrInfo',
  // 扫码获取授权状态
  AuthPoll: 'video_i18n.QrPoll/AuthPoll',
  // 查询账号状态 1账号格式非法；2跳注册；3跳重置密码；4跳登录
  checkAccount: 'trpc_account_check.AccountCheck/GetState',
  // 登录
  phoneLogin: 'trpc_web_login.WebLogin/Login',
  // 获取会员信息
  UserVIPInfo: 'trpc.video_app_international.trpc_user_info.TrpcUserInfo/UserVIPInfo',
  // 退出登录
  Logout: 'trpc_web_login.WebLogin/Logout',
  // 票据续期
  ReNew: 'trpc_web_login.WebLogin/ReNew',
  // 获取付费二维码
  paidCode: 'fcgi-bin/hw_comm_cgi?name=spp_inter_tv_shorturl_new&cmd=25523&otype=xjson',
  // 海外TV端预鉴权
  ProcessTVPreAuth: 'fcgi-bin/hw_comm_cgi?name=spp_inter_tv_pre_auth&otype=xjson',
  // 直播详情
  liveDetail: 'trpc.video_app_international.trpc_live_detail.LiveDetail/GetLiveDetail',
  // 直播
  liveStreaming: 'trpc.video_app_international.trpc_live_poll.LivePoll/GetLivePoll',
  // 直播多机位
  liveMultiCamera: 'trpc.video_app_international.trpc_live_poll.LivePoll/GetMultiCamera',
  // 剧集断点续播
  // eslint-disable-next-line
  lastPlay: 'trpc.video_app_international.trpc_history_read.HistoryRead/RPCQuerySingleHistory',
  // 观看历史上报
  // eslint-disable-next-line
  historyReport: 'trpc.video_app_international.trpc_history_write.HistoryWrite/RPCReportHistory',
  // wetv会员开通
  // eslint-disable-next-line
  CreateGuidIntl: 'rpc/trpc.long_link_group.inter_long_link_intl.InterLongLinkIntl/CreateGuidIntl',
  // 用户的跨端支付结果轮询
  // eslint-disable-next-line
  GetMsgIntl: 'rpc/trpc.long_link_group.inter_long_link_intl.InterLongLinkIntl/GetMsgIntl',
  // 详情页定位与翻页接口
  // eslint-disable-next-line
  getDetailPage: 'trpc.video_app_international.trpc_d_video_detail.VideoDetailData/GetDetailList',
  // 错误日志上报
  UploadLog: 'trpc.video_app_international.trpc_aisee_hook.AiSee/UploadLog',
  // 用户年龄信息提交
  UserInfoWrite: 'trpc.video_app_international.trpc_user_info.TrpcUserInfo/UserInfoWrite',
  // 获取用户信息
  GetUserInfo: 'trpc.video_app_international.trpc_user_info.TrpcUserInfo/UserInfoRead',
  // 年龄授权确认接口
  SetUserGrant: 'trpc.video_app_international.trpc_user_grant.TrpcUserGrant/RPCGrant',
  // 会员开通Astro侧验证账号信息
  CheckChannelAccount: 'trpc_identity_info.IdentityInfo/VerifyIdentity?video_appid=1200012',
  // 获取直播详情页数据
  GetLiveDetail: 'trpc.video_app_international.trpc_live_detail.LiveDetail/GetLiveDetail',
  // 直播轮询接口(轮询获取直播的状态)
  LivePoll: 'trpc.video_app_international.trpc_live_poll.LivePoll/GetLivePoll',
  // 直播多机位轮询接口
  GetLiveMultiCamera: 'trpc.video_app_international.trpc_live_poll.LivePoll/GetMultiCamera',
};
